import View from "../framework/view";
import Server from "../server";
import jQuery from "jquery";
import {Order} from "../bo/order";
import {isDelivery} from "../misc/orders";
import {Map_, Markers_} from "../google/apis";
import LatLngBounds = google.maps.LatLngBounds;
import {_calcRoute} from "../misc/maps";


export const west_row_botanica = { lat: -35.279141, lng: 149.127910 };

export interface LatLng {
    lat: number,
    lng: number
};

interface CalcRouteResults {
    results: google.maps.DirectionsResult[],
    orderedOrders: Order[]
};

export interface PinConfig {
    glyphColor?: string,
    background?: string,
    borderColor?: string,
    glyph?: string
}

export type PinConfigFunction =  (order: Order) => PinConfig | undefined;

export class MapView extends View {

    static classname = "map-view";

    private readonly server = Server.instance();

    private orders: Order[] | undefined;

    private map? : any;

    private cachedElt: JQuery<HTMLElement> | undefined = undefined;

    private boundsChanging = false;

    private pinFunction? : PinConfigFunction;

    constructor() {
        super(MapView.classname);
    }

    setOrders(orders: Order[]) {
        this.orders = orders;
        this.cachedElt = undefined;
        this.update();
    }

    setPinFunction(f: PinConfigFunction) {
        this.pinFunction = f;
    }

    public calcRoute(origin: LatLng, destination: LatLng, orders: Order[]) : Promise<CalcRouteResults | null> {
        return new Promise((resolve, reject) => {
            _calcRoute(origin, destination, orders, resolve, reject, this.map);
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const isCached = () => {
            const cached = this.cachedElt && this.cachedElt.closest("body").length > 0 ? this.cachedElt : false;
            return cached;
        }

        const cached = isCached();
        if (cached) {
            return cached;
        }

        const out = jQuery("<div style='height: 100%; min-height: 600px; width: 100%; margin-left: auto; margin-right: auto;'></div>");

        this.afterUpdate(() => {

            if (isCached()) {
                return;
            }

            const elt = this.elt()[0];

            const apis_ = Promise.all([Map_, Markers_]);

            Map_.then(Map => {

                Markers_.then(Markers => {

                    const orders = this.orders && this.orders.filter((order) => {
                        const address = isDelivery(order);
                        return address && address.geocoded;
                    }) || [];

                    const center = orders.length != 1 ? west_row_botanica : toPosition(orders[0]);
                    // @ts-ignore
                    const map = new Map(elt, {
                        center: west_row_botanica,
                        zoom: 11,
                        mapId: "DEMO_MAP_ID", // See https://developers.google.com/maps/documentation/javascript/map-ids/mapid-over for documentation
                    });

                    const infowindow = new google.maps.InfoWindow({
                        content: ""
                    });

                    var bounds = new google.maps.LatLngBounds();
                    for (const order of orders) {

                        const address = isDelivery(order);
                        if (address && address.geocoded) {
                            const position = {lat: address.lat, lng: address.lng};

                            const opts : any = {
                                position: position,
                                map,
                                title: String(order.number),
                            };

                            const config = this.pinFunction ? this.pinFunction(order) : undefined;
                            if (config) {
                                // @ts-ignore
                                const pin = new Markers.PinElement(config);
                                opts["content"] = pin.element;
                            }

                            // @ts-ignore
                            const marker = new Markers.AdvancedMarkerElement(opts);

                            marker.addListener("click", () => {
                                infowindow.setContent(`<a href="#/orders/view/${order.id}">${order.number}</a>`);
                                infowindow.open({
                                    anchor: marker,
                                    map: map
                                });
                            });

                            bounds.extend(position);
                        } else {

                        }
                        if (orders.length > 1) {
                            map.fitBounds(bounds);
                        }

                        this.map = map;

                        google.maps.event.addListener(map, "bounds_changed", () => {
                            this.boundsChanging = true;
                        });
                        google.maps.event.addListener(map, "idle", () => {
                            if (this.boundsChanging) {
                                this.boundsChanging = false;
                                this.elt().trigger("bounds_changed");
                            }
                        });
                    }

                    this.elt().trigger("bounds_changed");

                }).catch((err: any) => {
                    console.error("Markers failed", err);
                });

            }).catch((err: any) => {
                console.error("Map failed", err);
            });

            this.cachedElt = out;
        });

        return out;
    }

    public getBounds() : LatLngBounds | undefined {
        if (!this.map) {
            return undefined;
        }
        return this.map.getBounds();
    }

}

export const toPosition : (order: Order) => { lat: number, lng: number } | undefined = (order) => {
    const address = isDelivery(order);
    if (! address) {
        return undefined;
    }
    const position = { lat: address.lat, lng: address.lng };
    return position;
}


